module.exports = __webpack_public_path__ + "img/drug_enforcement-hotspot-4.92426456.png";